import { useQuery } from '@tanstack/react-query';
import { orderAPI } from '../api/orderAPI';
import { useMemo } from 'react';

import { readAppLanguage } from '../../../lib/useChangeLanguage';
import { orderDetailAdapter } from '../libs/orderDetailAdapter';

export const useGetOrderById = (id: string) => {
  const language = readAppLanguage();
  const initData = useMemo(() => ({ order: orderDetailAdapter() }), []);
  const { data = initData, isLoading } = useQuery({
    // Язык в ключе: ответ приходит переведённым (см. заголовок Language в
    // orderAPI), и после переключения языка кэш прошлого не подходит.
    queryKey: ['order', id, language],
    queryFn: async () => await orderAPI.getOrderById(id),
    select: data => ({ order: orderDetailAdapter(data.data) }),
    refetchInterval: 3 * 1000,
    refetchIntervalInBackground: true,
  });

  return {
    ...data,
    isLoading,
  };
};
